<script>
  import './style.scss';
  import template from './template.html';
  import axios from 'axios';
  import { ChevronDownIcon, ChevronUpIcon, CloseIcon } from '../icons.js';
  import {isEmpty, isObject} from 'lodash';
  import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
  import { required, email, min } from 'vee-validate/dist/rules';
  import { isUniqueEmail } from './validators.js';
  import { getLanguages, getUsers, mapTargetLanguages } from './utils.js';
  import debounce from 'lodash/debounce';
  import {mapState, mapMutations, mapActions} from 'vuex';

  extend('r_mail', email);

  extend('min', min);

  extend('required', {
    ...required,
    message: 'This field is required'
  });

  // how do I pass accountId?
  extend("unique", {
    validate: isUniqueEmail,
    message: 'The email is not unique'
  })

  function Reviewer () {
    let props = {
      id: Date.now(),
      r_mail: '',
      first_name: '',
      last_name: '',
      target_languages: [],
      notes: '',
    };

    Object.assign(this, props);
  }

  export default {

    props: {

      isVisible: {
        type: Boolean,
        default: false
      },

      isPm: {
        type: Boolean,
        default: false
      },

      reviewer: {
        type: Object,
        default: null
      },

      editMode: {
        type: Boolean,
        default: false
      },

      showBehalfForm: {
        type: Boolean,
        default: false
      }
    },

    created () {
      getLanguages().then((languages) => {
        this.languages = languages;

        this.addReviewer(this.editableReviewer);

        getUsers(this.languages).then(users => {
          //@TODO - when we validate on the backend, we should query db based on email first
          this.accountUsers = users;
        })
      });
    },

    computed: {

      selectOptions () {
        return this.reviewers.map(obj => {
          obj.full_name = `${obj.first_name} ${obj.last_name}`;
          return obj;
        });
      },

      popupTitle () {
        if (!this.reviewer || isEmpty(this.reviewer)) {
          return "Add Reviewer";
        }

        return "Edit Reviewer";
      },

      popupSubTitle () {
        if (!this.reviewer || isEmpty(this.reviewer)) {
          return "Who would you like to add as a reviewer?";
        }

        return "";
      },

      requestIsValid () {

      },

      editableReviewer () {
        if (!this.reviewer || isEmpty(this.reviewer)) return null;

        let {languages: reviewerLangs, first_name, last_name, name, email: r_mail} = this.reviewer;

        let target_languages = mapTargetLanguages(reviewerLangs, this.languages);

        let result = Object.assign({}, this.reviewer, {
          target_languages,
          first_name,
          last_name,
          r_mail
        });

        return result;
      },
      ...mapState('ReviewFormStore', [
        'onBehalfAccount',
      ])
    },

    methods: {
      ...mapActions('TRMOnBehalfStore', [
        'loadAccountData',
      ]),
      ...mapMutations('ReviewFormStore', ['setOnBehalfAccount']),
      getOptionKey (option) {
        if (typeof isObject(option) && option.id) {
          return option.id;
        }
        else {
          try {
            return JSON.stringify(option);
          }
          catch (e) {
            return console.warn(
                `[vue-select warn]: Could not stringify option ` +
                `to generate unique key. Please provide 'getOptionKey' prop ` +
              `to return a unique key for each option.\n` +
              'https://vue-select.org/api/props.html#getoptionkey'
            )
            return null
          }
        }
      },

      sendRequests ($event) {
        this.sendingRequests = true;

        axios.post('/review/reviewers', {
          reviewers: this.reviewers,
          accountId: this.onBehalfAccount.id
        })
            .then(this.onRequestsSent)
            .finally(() => {
              this.sendingRequests = false;
              this.loadAccountData('/accounts/with-reviewers');
            });
      },

      updateReviewer ($event) {
        axios.put('/review/reviewer', {
          reviewer: this.activeReviewer
        })
        .then(result => {
          this.$emit('reviewer-updated');
          this.closeRequestForm();
        })
      },

      onRequestsSent (result) {
        this.requestFormIsVisible = false;
        this.reviewerPopupIsVisible = true;
        this.createdReviewers = result.data.users;
      },

      switchActiveReviewer (reviewer) {
        const {first_name, id} = this.activeReviewer;

        this.setActiveReviewer(reviewer);

        //if user didn't finish entering users name before switching
        //then remove this obj, so we don't have empty/invalid reviewer objects
        //in the reviewers array
        if (!first_name || first_name.length < 1) {
          let indx = this.reviewers.findIndex(r => r.id == id);

          this.reviewers.splice(indx, 1);
        }
      },

      //@TODO
      //we're hiding the email
      //field and then adding the correct value for validation
      //when we type in the select search
      onBlurEmail ($event, item) {
        this.$nextTick(() => {
          let selectInput = $($event.target).val();

          //item.r_mail = selectInput;

          //this.$forceUpdate();

          this.validateEmail();
        });
      },

      fillReviewer (user, item) {
        let {first_name, last_name, email, notes, languages} = user;

        item = Object.assign(item, {
          r_mail: email,
          first_name,
          last_name,
          notes,
          languages: languages || {}
        })

        this.validateEmail();
      },

      validateEmail () {
        this.$nextTick(() => this.$refs.email_validation[0].validate())
      },

      setActiveReviewer (reviewer) {
        reviewer = reviewer || {};

        this.activeReviewer = reviewer;
      },

      isActiveReviewer(item) {
        return this.activeReviewer.id == item.id;
      },

      addReviewer (reviewerObj) {
        let r = reviewerObj || (new Reviewer());

        this.reviewers.push(r);

        this.setActiveReviewer(r);
      },

      closeRequestForm () {
        this.$emit('toggle-form', {state: false});
      },

      finishRequestForm () {
        this.$emit('toggle-form', {state: false});
        this.$emit('finish-form');
      },

      inPlunet (reviewer) {
        return !isEmpty(reviewer.plunetid) || reviewer.role !== "review_only";
      },
      onAccountSearch (search) {
        if (search.length) {
          this.searchAccount(search, this);
        }
      },
      searchAccount:
          debounce((term, vm) => {
            axios.get(
                `/accounts/all?search=${term}`
            ).then(res => {
              vm.accounts = res.data;
            });
          }, 600)
    },


    template,

    data () {

      return {
        activeReviewer: {},

        reviewers: [],

        languages: [
          { name: 'English', code: 'EU'},
          { name: 'Russian', code: 'RU'}
        ],

        accountUsers: [],

        createdReviewers: [],

        isActive: false,

        requestFormIsVisible: true,

        reviewerPopupIsVisible: false,

        sendingRequests: false,

        accounts: [{
          'id': backend.user.usergroup.id,
          'name': backend.user.usergroup.company,
        }]
      }
    },

    components: {
      ChevronDownIcon,
      ChevronUpIcon,
      CloseIcon,
      ValidationProvider,
      ValidationObserver
    }
  };
</script>
